export enum RiskLevelColour {
  low = 'bg-green-500',
  medium = 'bg-yellow-500',
  high = 'bg-red-500'
}
